import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Button from '../../../../core/form/Button';
import Breadcrumb from '../../../../core/layout/Breadcrumb';
import Card from '../../../../core/layout/Card';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import Separator from '../../../../core/layout/Separator';
import { get } from 'lodash';
import ContentCourseFailureAttemptRateTableContainer from './course/ContentCourseFailureAttemptRateTableContainer';
import ContentCourseErrorRateTableContainer from './course/ContentCourseErrorRateTableContainer';
import ContentCourseRepeatRateTableContainer from './course/ContentCourseRepeatRateTableContainer';
import ContentCourseSpeechRateTableContainer from './course/ContentCourseSpeechRateTableContainer';
import KpiReferenceMonth from '../../commons/KpiReferenceMonth';
import ContentCourseDetailSummary from './ContentCourseDetailSummary';

const ContentCourseDetailScene = (props) => (
  <div>
    <Breadcrumb
      fetching={props.isLoading}
      crumbs={[
        {
          text: "KPI's Content",
          link: `/kpis/content`,
        },
        {
          text: get(props.course, 'name'),
          link: `/kpis/content/course/${get(props.course, 'id')}/details`,
        },
        ...(props.module
          ? [
              {
                text: get(props.module, 'name'),
                link: `/kpis/content/course/${get(props.course, 'id')}/module/${get(props.module, 'id')}/details`,
              },
            ]
          : []),
        ...(props.unit
          ? [
              {
                text: get(props.unit, 'name'),
                link: `/kpis/content/course/${get(props.course, 'id')}/module/${get(props.module, 'id')}/unit/${get(
                  props.unit,
                  'id'
                )}/details`,
              },
            ]
          : []),
      ]}
    />
    <Card
      loading={props.isLoading}
      title={`
        ${get(props.course, 'id', false) ? 'Course / Modules' : ''}
        ${get(props.module, 'id', false) ? ' / Units' : ''}
        ${get(props.unit, 'id', false) ? ' / Items' : ''}
      `}
      actions={<Button icon="arrow-left" label="back" onClick={() => browserHistory.goBack()} />}
    >
      <KpiReferenceMonth />
    </Card>
    <Separator />
    <Card
      loading={props.isLoading}
      title={`Summary - ${
        props.unit
          ? `Unit: ${props.unit.name}`
          : props.module
          ? `Module: ${props.module.name}`
          : `Course: ${props.course?.name}`
      }`}
    >
      <ContentCourseDetailSummary />
    </Card>
    <Separator />
    <Card loading={props.isLoading}>
      <Row>
        <Column size={6}>
          <ContentCourseFailureAttemptRateTableContainer
            courseId={get(props.course, 'id')}
            moduleId={get(props.module, 'id')}
            unitId={get(props.unit, 'id')}
          />
        </Column>
        <Column size={6}>
          <ContentCourseRepeatRateTableContainer
            courseId={get(props.course, 'id')}
            moduleId={get(props.module, 'id')}
            unitId={get(props.unit, 'id')}
          />
        </Column>
      </Row>
      <Separator />
      <Row>
        <Column size={6}>
          <ContentCourseSpeechRateTableContainer
            courseId={get(props.course, 'id')}
            moduleId={get(props.module, 'id')}
            unitId={get(props.unit, 'id')}
          />
        </Column>
        {!get(props.unit, 'id', false) && (
          <Column size={6}>
            <ContentCourseErrorRateTableContainer
              courseId={get(props.course, 'id')}
              moduleId={get(props.module, 'id')}
              unitId={get(props.unit, 'id')}
            />
          </Column>
        )}
      </Row>
    </Card>
  </div>
);

ContentCourseDetailScene.propTypes = {
  course: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  module: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  unit: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  isLoading: PropTypes.bool.isRequired,
};

export default ContentCourseDetailScene;
